import { csrf } from "../utils/csrf"

const client = {
  get (path) {
    const opts = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }

    return fetch(path, opts).then(this.unwrap)
  },

  post (path, params) {
    const opts = {
      method: "POST",
      redirect: "manual",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrf()
      },
      body: JSON.stringify(params)
    }

    return fetch(path, opts).then(this.unwrap)
  },

  patch (path, params) {
    const opts = {
      method: "PATCH",
      redirect: "manual",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrf()
      },
      body: JSON.stringify(params)
    }

    return fetch(path, opts).then(this.unwrap)
  },

  put (path, params) {
    const opts = {
      method: "PUT",
      redirect: "manual",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrf()
      },
      body: JSON.stringify(params)
    }

    return fetch(path, opts).then(this.unwrap)
  },

  delete (path, params) {
    const opts = {
      method: "DELETE",
      redirect: "manual",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrf()
      },
      body: JSON.stringify(params)
    }

    return fetch(path, opts).then(this.unwrap)
  },

  unwrap (response) {
    if (response.type === "opaqueredirect") {
      return Promise.resolve(response)
    } else if (!response.ok) {
      const error = new Error(response.statusText)
      error.response = response
      throw error
    } else {
      return response.json()
    }
  },
}

export { client }
